import api from '@/api';

import { PageResult } from '@/core/request/PageResult';
import { PageRequest } from '@/core/request/PageRequest';

import { API_BASE_URL } from '..';
import {
  BankingEntry,
  BankingEntryCreateRequest,
  BankingEntryListReturn,
  BankingEntryReversalRequest,
  BankingEntryUpdateRequest,
} from './BankingEntry.types';

const CONTROLLER_URL = `${API_BASE_URL}/bankingEntry`;

export async function listBankingEntries(
  params?: PageRequest,
): Promise<PageResult<BankingEntryListReturn>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<BankingEntryListReturn>;
}

export async function createBankingEntry(
  obj: BankingEntryCreateRequest,
): Promise<BankingEntry> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as BankingEntry;
}

export async function reversalBankingEntry(
  obj: BankingEntryReversalRequest,
): Promise<BankingEntryListReturn> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}/Reversal`,
    obj,
    null,
  )) as unknown;

  return result as BankingEntryListReturn;
}

export async function updateBankingEntry(
  obj: BankingEntryUpdateRequest,
): Promise<BankingEntry> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}`,
    obj,
    null,
  )) as unknown;

  return result as BankingEntry;
}

export async function getBankingEntry(id: number) {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as BankingEntry;
}
